import { Box, Paper, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

export default function Nested(props) {
  const nestedData = props.formData[props.field.name] || {};

  const updateNestedField = (path, value) => {
    props.setFormData((prev) => {
      const pathArray = path.split('.');
      const result = { ...prev };
      let current = result;

      for (let i = 0; i < pathArray.length - 1; i++) {
        const key = pathArray[i];
        if (!(key in current)) {
          current[key] = isNaN(pathArray[i + 1]) ? {} : [];
        }
        current = current[key];
      }

      current[pathArray[pathArray.length - 1]] = value;
      return result;
    });
  };

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Box display="flex" flexDirection="column" gap={1}>
        {props.field.fields.map((subField) => {
          const value = nestedData[subField.name] || '';

          return (
            <Box key={subField.name}>
              <Typography variant="subtitle2" gutterBottom>
                {subField.label}
              </Typography>

              {subField.type === 'text' ? (
                <TextField
                  id={`field-${props.field.name}-${subField.name}`}
                  variant="outlined"
                  label={subField.label}
                  name={`${props.field.name}.${subField.name}`}
                  value={value}
                  onChange={(e) =>
                    updateNestedField(
                      `${props.field.name}.${subField.name}`,
                      e.target.value,
                    )
                  }
                  placeholder={subField.placeholder}
                  fullWidth
                  multiline={Boolean(subField.multiline)}
                  minRows={subField.multiline ? (subField.minRows ?? 1) : undefined}
                  maxRows={subField.multiline ? subField.maxRows : undefined}
                  InputProps={{
                    id: `field-${props.field.name}-${subField.name}-input`,
                  }}
                  slotProps={{
                    htmlInput: {
                      id: subField.multiline 
                        ? `field-${props.field.name}-${subField.name}-textarea`
                        : `field-${props.field.name}-${subField.name}-input`,
                      name: `${props.field.name}.${subField.name}`,
                    }
                  }}
                  InputLabelProps={{
                    htmlFor: subField.multiline 
                      ? `field-${props.field.name}-${subField.name}-textarea`
                      : `field-${props.field.name}-${subField.name}-input`,
                  }}
                  sx={subField.multiline ? { '& textarea': { resize: 'vertical' } } : undefined}
                />
              ) : subField.type === 'date' ? (
                <DatePicker
                  label={subField.label}
                  value={value || null}
                  onChange={(newValue) =>
                    updateNestedField(
                      `${props.field.name}.${subField.name}`,
                      newValue,
                    )
                  }
                  slotProps={{
                    textField: {
                      id: `field-${props.field.name}-${subField.name}`,
                      variant: 'outlined',
                      fullWidth: true,
                      name: `${props.field.name}.${subField.name}`,
                      placeholder: subField.placeholder,
                    },
                  }}
                />
              ) : (
                <Typography color="error">
                  Unsupported nested type: {subField.type}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    </Paper>
  );
}
